import * as React from 'react';
import {CONTACT_TAB} from '../../../Config/appConfig';
import ApiUserList from '../CompanyList/ApiUserList';

class ApiUserController extends React.Component {
    public render() {
        return (<ApiUserList currentTab={CONTACT_TAB.API_USER}/>);
    }
}

export default ApiUserController;



// WEBPACK FOOTER //
// ./src/Components/Contact/ContactController/ApiUserController.tsx